import { forwardRef } from 'react';
import { NumberFormatValues, NumericFormat, NumericFormatProps } from 'react-number-format';

export interface NumberFormatCustomProps extends NumericFormatProps {
  focusedBorderColor?: string;
  borderColor?: string;
}

export interface NumberFormatCustomValues extends NumberFormatValues {}

export const NumberFormatCustom = forwardRef<HTMLInputElement, NumberFormatCustomProps>((props, ref) => {
  const { style, focusedBorderColor, borderColor, onFocus, onBlur, ...rest } = props;

  return (
    <NumericFormat
      onFocus={onFocus}
      onBlur={onFocus}
      style={{
        borderRadius: '6px',
        padding: '-1px',
        width: '100%',
        ...style,
      }}
      getInputRef={ref}
      {...rest}
    />
  );
});
